import type { ComputedRef } from 'vue'
import type { LinkBreadcrumbItem } from '@shared/ui/menus'

import { useCanonicalRoute } from '@shared/lib/routes'
import { AppRoute } from '@shared/config'

interface TaskInfoHeaderReturn {
  config: ComputedRef<LinkBreadcrumbItem[]>
}

export const useTaskInfoHeader = (): TaskInfoHeaderReturn => {
  const route = useRoute()
  const { canonicalUrl } = useCanonicalRoute({ key: 'tasks-kanban-referrer' })

  const config = computed<LinkBreadcrumbItem[]>(() => [
    {
      id: 'tasks-kanban',
      text: 'Tasks Kanban',
      to: canonicalUrl.value ?? AppRoute.TasksKanbanSupport,
      disabled: false,
    },
    {
      id: 'task-info',
      text: `Task/${route.params.id}`,
      to: AppRoute.TasksKanbanSupport,
      disabled: true,
    },
  ])

  return {
    config,
  }
}
